import { render } from "./GenrePicker.vue?vue&type=template&id=5a44cab8"
import script from "./GenrePicker.vue?vue&type=script&lang=js"
export * from "./GenrePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__